module.exports = __webpack_public_path__ + "static/media/layout.918f7e5a.svg";